import { INSTRUCTIONS, TESTS } from "./steps";
export { INSTRUCTIONS, TESTS } from "./steps";

const STEPS = [INSTRUCTIONS, TESTS];

export default STEPS;
